import React from 'react'
import toKFormattedNumberUtil from 'utils/number/to-k-formatted'
import './index.css'

const ProductCardLikeAndSuperLike = ({ likedCount, superLikedCount }) => {
  return (
    <div className='product-card-like-and-super-like'>
      {superLikedCount > 0 && (
        <div className='super-like-container'>
          <svg className='super-like-icon' width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M4.8469 7.12174C4.51061 7.12174 4.15327 7.19034 3.77964 7.34773C2.14708 8.035 1.73365 9.76518 2.04037 11.082C2.79255 14.3129 6.89981 16.1579 7.41708 16.3783C7.93435 16.1576 12.0418 14.3106 12.7936 11.082C13.1004 9.76518 12.6869 8.03486 11.0542 7.34758C9.46307 6.67761 8.16608 7.61499 7.53908 8.62113C7.48659 8.70585 7.34786 8.70585 7.29494 8.62113C6.81502 7.8513 5.94287 7.12174 4.8469 7.12174Z' fill='#4439DF' />
            <path fillRule='evenodd' clipRule='evenodd' d='M8.94541 3.84822C9.31905 3.69082 9.67639 3.62223 10.0127 3.62223C11.1086 3.62223 11.9808 4.35179 12.4607 5.12161C12.5136 5.20634 12.6524 5.20634 12.7048 5.12161C13.3319 4.11548 14.6288 3.17809 16.22 3.84807C17.8527 4.53535 18.2661 6.26566 17.9594 7.58251C17.3414 10.2362 14.4565 11.9565 13.1615 12.6076C13.5254 12.057 13.8097 11.4564 13.9696 10.8074C14.3434 9.29017 13.8395 7.29654 11.8498 6.50469C9.91059 5.73276 8.32994 6.81279 7.5658 7.97203C7.51785 8.04521 7.41083 8.06353 7.33308 8.02699C7.28389 7.88188 7.24135 7.73372 7.20614 7.58251C6.89942 6.26566 7.31286 4.53549 8.94541 3.84822Z' fill='#9C99EE' />
          </svg>
          <span className='super-like-count'>{toKFormattedNumberUtil(superLikedCount)}</span>
        </div>
      )}

      {likedCount > 0 && (
        <div className='like-container'>
          <svg className='like-icon' width='14' height='12' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M3.66202 0.377633C3.25218 0.377633 2.81668 0.46123 2.36133 0.653042C0.371717 1.4906 -0.132144 3.59912 0.241666 5.20393C1.15835 9.14131 6.16392 11.3897 6.79432 11.6584C7.42472 11.3894 12.4305 9.13848 13.3468 5.20393C13.7206 3.59912 13.2167 1.49043 11.227 0.652865C9.28779 -0.163621 7.70714 0.978751 6.943 2.2049C6.87903 2.30815 6.70996 2.30815 6.64546 2.2049C6.06058 1.26674 4.99768 0.377633 3.66202 0.377633Z' fill='#E15EC4' />
          </svg>
          <span className='like-count'>{toKFormattedNumberUtil(likedCount)}</span>
        </div>
      )}
    </div>
  )
}

export default ProductCardLikeAndSuperLike
